import script from "./GallerySkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./GallerySkeleton.vue?vue&type=script&setup=true&lang=js"

import "./GallerySkeleton.vue?vue&type=style&index=0&id=0de4fdc6&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0de4fdc6"]])

export default __exports__